

import { Component } from '@angular/core';

@Component({
  selector: 'icon-reload',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M1 13C1 9.8174 2.26428 6.76516 4.51472 4.51472C6.76516 2.26428 9.8174 1 13 1C16.3547 1.01262 19.5747 2.32163 21.9867 4.65333L25 7.66667M25 7.66667V1M25 7.66667H18.3333M25 13C25 16.1826 23.7357 19.2348 21.4853 21.4853C19.2348 23.7357 16.1826 25 13 25C9.64527 24.9874 6.42529 23.6784 4.01333 21.3467L1 18.3333M1 18.3333H7.66667M1 18.3333V25" stroke="#F8F9FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    @import '../assets/colors.scss';

    svg{
        cursor: pointer;
        path{
          stroke: $text_header_color
        }
    }
  `
})

export class ReloadIconComponent {}
